import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import cell from './cell/cell.js'
import filter from './filter.js'
import list from './list.js'

export default contract({
  cell,
  filter: array([
    filter
  ]),
  list: array([
    list
  ])
})
